require('../../modules/es.object.get-prototype-of');
var path = require('../../internals/path');

module.exports = path.Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/get-prototype-of.js
// module id = 420
// module chunks = 0 1